module.exports = __webpack_public_path__ + "img/home-movil.5f8749e7.png";